<script setup lang="ts"></script>

<template>
    <header class="card-header full-width">
        <div class="card-header-title">
            <slot />
        </div>
    </header>
</template>
